<template>
  <div :class="b()" :style="styleSizeName">
    <div v-show="hasData" :ref="id" :style="styleChartName"></div>
    <template v-if="!hasData">
      <empty></empty>
    </template>
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'sankey',
  mixins: [init],
  computed: {
    x2() {
      return this.option.gridX2 || 20;
    },
    hasData() {
      return this.dataChart?.series;
    }
  },

  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart) || [];
      optionData.series.data.map((o, i) => {
        o.itemStyle = this.ishasprop(
          !this.switchTheme,
          {
            color: this.getColor(i)
          },
          {}
        );
      });
      const option = {
        title: this.ishasprop(
          this.option.titleShow,
          {
            text: this.option.title,
            subtext: this.option.subtext || '',
            textStyle: {
              color: this.option.titleColor || '#333',
              fontSize: this.option.titleFontSize || 16
            },
            left: this.option.titlePostion || 'auto',
            subtextStyle: {
              color: this.option.subTitleColor || '#aaa',
              fontSize: this.option.subTitleFontSize || 14
            }
          },
          {}
        ),
        tooltip: {
          show: true,
          trigger: 'item',
          triggerOn: 'mousemove'
        },
        series: {
          type: 'sankey',
          data: optionData.series.data,
          links: optionData.series.links,
          label: {
            show: this.vaildData(this.option.labelShow, false), //开启显示
            position: 'right', //在右方显示,
            align: 'center',
            textStyle: {
              //数值样式
              fontSize: this.option.labelShowFontSize || 14,
              color: this.option.labelShowColor || '#333',
              fontWeight: this.option.labelShowFontWeight || 500
            }
            // formatter: name => this.getLabelFormatter(name),
          },
          left: this.option.gridX,
          top: this.option.gridY,
          right: this.x2,
          bottom: this.option.gridY2,
          orient: this.option.orient ? 'vertical' : 'horizontal',
          nodeWidth: this.option.nodeWidth,
          nodeGap: this.option.nodeGap,
          nodeAlign: 'left',
          lineStyle: {
            color: 'source', //gradient
            curveness: 0.5
          }
        }
      };

      this.myChart.resize();
      this.myChart.setOption(option, true);

      this.chartClick();
    }
  }
};
</script>
